import { theme, useResponsive } from "@product/scmp-sdk";
import React from "react";
import { graphql, useFragment } from "react-relay";

import { useNewsletterListContext } from "scmp-app/components/newsletter/newsletter-list/newsletter-category-item-list/contexts";
import type { newsletterItemCardNewsletter$key } from "scmp-app/queries/__generated__/newsletterItemCardNewsletter.graphql";

import Preview from "./preview.svg";
import { Container, Description, PreviewContainer, StyledCheckbox, Summary, Title } from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement> & {
  isChecked: boolean;
  onCheck?: (isChecked: boolean) => void;
  reference: newsletterItemCardNewsletter$key;
};

export const NewsletterItemCard: React.FunctionComponent<Props> = ({
  isChecked,
  onCheck,
  reference: reference_,
}) => {
  const isMobile = useResponsive(theme.breakpoints.only("mobile"));
  const { activeNewsletterId, setActiveNewsletterId, setIsDisplayMobilePreview } =
    useNewsletterListContext();
  const newsletter = useFragment(
    graphql`
      fragment newsletterItemCardNewsletter on Newsletter {
        entityId
        name
        description {
          text
        }
        summary {
          text
        }
      }
    `,
    reference_,
  );

  const isFocused = activeNewsletterId === newsletter.entityId;
  return (
    <Container $isFocused={isFocused} onClick={() => setActiveNewsletterId(newsletter.entityId)}>
      <StyledCheckbox $checked={isChecked} onClick={() => onCheck?.(isChecked)} />
      <Summary>{newsletter?.summary?.text}</Summary>
      <PreviewContainer
        $isFocused={isFocused}
        onClick={() => {
          if (isMobile)
            setIsDisplayMobilePreview(isDisplayMobilePreview => !isDisplayMobilePreview);
        }}
      >
        <Preview />
      </PreviewContainer>
      <Title>{newsletter.name}</Title>
      {isFocused && <Description>{newsletter?.description?.text}</Description>}
    </Container>
  );
};

NewsletterItemCard.displayName = "NewsletterItemCard";
